<div class="modal-header">
  <h3 class="modal-title">Report generic QA issue</h3>
  <button
    type="button"
    class="copy-link"
    kendoTooltip
    title="Copy link"
    (click)="createAndCopyLink()">
    <span class="k-icon k-font-icon k-i-link"></span>
  </button>
  <button type="button" class="close" (click)="dismiss()" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <kendo-panelbar [items]="panelItems">
    <ng-template kendoPanelBarItemTemplate let-dataItem>
      @if (isClient(dataItem)) {
        <div class="panel-item-wrapper">
          <app-searchable-list-micro
            [selectedItems]="selectedItems"
            [resourceUrl]="clientsUrl"
            [config]="clientsConfig"
            (changeValue)="changeFilter($event)"></app-searchable-list-micro>
          <div class="empty-space"></div>
          <app-work-items-qa-report-client
            [clientInfo]="clientInfo"></app-work-items-qa-report-client>
          <div class="empty-space"></div>
          <app-work-items-qa-report-target-task-selection
            (selectedProcessNodeIdChanged)="
              selectedProcessNodeIdChanged($event)
            "></app-work-items-qa-report-target-task-selection>
        </div>
      }

      @if (isTask(dataItem)) {
        <div class="panel-item-wrapper">
          @if (qaReportTaskExchange) {
            <app-work-items-qa-report-task
              [qaReportTaskExchange]="qaReportTaskExchange"
              [qaFormExchange]="qaFormExchange"
              (taskSelected)="
                taskSelected($event)
              "></app-work-items-qa-report-task>
          }
        </div>
      }

      @if (isForm(dataItem)) {
        <div class="panel-item-wrapper">
          @if (qaFormExchange && qaTask) {
            <app-work-items-qa-report-form
              [qaFormExchange]="qaFormExchange"
              [task]="qaTask"></app-work-items-qa-report-form>
          }
        </div>
      }
    </ng-template>
  </kendo-panelbar>
</div>

<div class="modal-footer justify-content-between">
  <button type="button" class="btn btn-secondary btn-sm" (click)="dismiss()">
    Cancel
  </button>
  <div>
    <button
      type="button"
      class="btn btn-primary btn-sm"
      (click)="save()"
      [disabled]="!canSave">
      Save
    </button>
  </div>
</div>
